import { PageSource, PrePaywallPageSource } from '@mc/track-event'

import { usePageSource } from './usePageSource'

const VALID_PAGE_SOURCES = [
  PageSource.HOMEPAGE,
  PageSource.CLASS_PAGE,
  PageSource.SERIES_PAGE,
  PageSource.CATEGORY,
  PageSource.SUBCATEGORY,
  PageSource.SESSIONS_HOME,
  PageSource.SESSIONS_CLASS,
  PageSource.OUTCOME,
] as PrePaywallPageSource[]

export const useExperimentCriteria = () => {
  const pageSource = usePageSource()

  return VALID_PAGE_SOURCES.includes(pageSource)
}
